const message = {
  "button.home.sendFiles": "Dateien senden",

  "button.options.record": "Jetzt aufnehmen",
  "button.options.upload": "Dateien auswählen",
  "button.options.gallery": "Album ansehen",
  "button.options.bingoGame": "Bingo",
  "button.options.photoChallengeGame": "Foto-Herausforderung",
  "button.options.quizGame": "Quiz",
  "button.options.teamMatchGame": "Team-Match",
  "button.options.foodMenu": "Speisekarte",
  "button.options.schedule": "Zeitplan",
  "button.options.feed": "Feed der Party",
  "message.options.bingoGame": "Spielen Sie das Party-Bingo!",
  "message.options.photoChallengeGame":
    "Nehmen Sie an der Foto-Herausforderung teil!",
  "message.options.quizGame": "Testen Sie Ihr Wissen!",
  "message.options.teamMatchGame": "Zu welchem Team gehören Sie?",
  "message.options.foodMenu": "Sehen Sie sich die Speisekarte der Party an!",
  "message.options.schedule": "Überprüfen Sie den Veranstaltungsplan!",
  "message.options.record": "Nehmen Sie jetzt Ihre spezielle Nachricht auf!",
  "message.options.upload": "Teilen Sie die besten Fotos und Videos der Party!",
  "message.options.gallery": "Sehen Sie sich die Fotos der Veranstaltung an!",
  "message.options.feed": "Verfolgen Sie die Timeline des Events!",

  "title.terms": "Nutzungsbedingungen",
  "title.notFound": "Ups, diese Seite scheint nicht zu existieren.",
  "title.eventNotFound": "Fehler beim Zugriff auf die Veranstaltung",

  "subtitle.goBackTo": "Zurück zu",
  "subtitle.eventNotFound": "Veranstaltung nicht gefunden oder abgelaufen.",

  "message.termsOfUse":
    "Durch die Nutzung unseres Systems stimmen Sie unseren <code>Nutzungsbedingungen</code> zu",
  "message.termsFirstParagraph":
    "Durch die Nutzung unseres Foto- und Video-Upload-Systems stimmen Sie als Gast der Veranstaltung zu, dass wir Ihre Daten, einschließlich Fotos, Videos und persönlicher Informationen, sammeln und an den Gastgeber der Veranstaltung weitergeben.",
  "message.termsSecondParagraph":
    "Wir greifen nur auf Ihre Dateien zu, wenn dies vom Kunden zur technischen Unterstützung angefordert wird, und beschränken uns auf das Notwendige.",
  "message.termsThirdParagraph":
    "Das Unternehmen teilt die Daten nicht mit Dritten und wahrt die Vertraulichkeit der Informationen, es sei denn, dies ist gesetzlich vorgeschrieben.",
  "message.shareLink": "Teilen Sie Ihre Lieblingsmomente der Party!",

  // recorder
  "button.recorder.understood": "Verstanden!",
  "button.recorder.close": "Schließen",
  "button.recorder.share": "Teilen",
  "button.recorder.home": "Zur Startseite zurückkehren",
  "button.recorder.back": "Zurück",

  "title.recorder.permissionsToRecordAudioVideo": "Erlaubnis zur Aufnahme",
  "title.recorder.success": "Erfolg!",
  "title.recorder.uploading": "Hochladen",
  "title.recorder.alert": "Warnung!",
  "title.recorder.saving": "Speichern",
  "title.recorder.waiting": "Warten",
  "title.recorder.share": "Teilen!",
  "title.recorder.error": "Fehler!",
  "title.recorder.permissionCameraOrMicrophoneDenied":
    "Erlaubnis nicht erteilt",
  "title.recorder.terms": "Nutzungsbedingungen",

  "subtitle.recorder.nextScreenClickAllow":
    "Klicken Sie im nächsten Bildschirm auf <code>Erlauben</code>.",
  "subtitle.recorder.allowReinforcement":
    "Sie müssen auf <code>Erlauben</code> klicken, um Ihre Nachricht aufzunehmen.",
  "subtitle.recorder.share": "Laden Sie Ihre Freunde ein, auch aufzunehmen!",
  "subtitle.recorder.dontRefreshPage":
    "Bitte aktualisieren oder schließen Sie diese Seite nicht.",
  "subtitle.recorder.status.success":
    "Ihre Nachricht wurde erfolgreich aufgenommen!",
  "subtitle.recorder.browserNotSupported":
    "Ihr Browser wird nicht unterstützt oder die Erlaubnis wurde nicht erteilt.",
  "subtitle.recorder.tryGrantPermission":
    "1. Aktualisieren Sie die Seite und erlauben Sie die Nutzung der Kamera.",
  "subtitle.recorder.tryAnotherBrowser":
    "2. Versuchen Sie, einen anderen Browser wie {chrome} oder {safari} zu verwenden.",
  "subtitle.recorder.mustLongerThan":
    "Die Nachricht muss länger als <code>5 Sekunden</code> sein.",
  "subtitle.recorder.offline":
    "Sie sind offline. Bitte überprüfen Sie Ihre Verbindung.",
  "subtitle.recorder.startRecord": "Klicken Sie, um die Aufnahme zu starten.",
  "subtitle.recorder.recording": "Aufnahme läuft...",
  "subtitle.recorder.uploadError": "Fehler beim Hochladen des Videos.",
  "subtitle.recorder.tryAgain":
    "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "subtitle.recorder.permissionCameraOrMicrophoneDenied":
    "Die Nutzung der Kamera/Mikrofons wurde nicht erlaubt.",
  "subtitle.recorder.trySafariBrowser":
    "1. Verwenden Sie den Browser <code>SAFARI</code>.",
  "subtitle.recorder.changeSiteSettingsUsingSafari":
    '2. Klicken Sie auf die Schaltfläche <code>"aA"</code> in der URL-Leiste und auf <code>"Website-Einstellungen"</code>',
  "subtitle.recorder.grantCameraAndMicrophonePermissions":
    "3. <code>Erlauben Sie die Nutzung</code> der Kamera und des Mikrofons",
  "subtitle.recorder.refreshPage": "4. Aktualisieren Sie die Seite",
  "subtitle.recorder.tryChromeBrowser":
    "1. Verwenden Sie den Browser <code>CHROME</code>",
  "subtitle.recorder.changeSiteSettingsUsingChrome":
    '2. Gehen Sie zu den Website-Einstellungen und klicken Sie auf <code>"Berechtigungen"</code>',

  "message.recorder.almostDone": "Fast fertig! Nur noch ein paar Sekunden.",
  "message.recorder.sendingMessage":
    "Wir senden jetzt Ihre Nachricht. Es kann eine Weile dauern, weil sie voller cooler Sachen ist.",

  "title.recorder.upload": "Upload",

  "subtitle.recorder.filesReadyToUpload": "Datei bereit zum Hochladen:",

  "subtitle.recorder.fileWithError": "Datei, die nicht hochgeladen wird:",

  "message.recorder.fileSizeError":
    "Dateigröße überschreitet das erlaubte Limit",

  "button.recorder.send": "Senden",

  "message.recorder.uploading":
    "Bitte aktualisieren oder schließen Sie diese Seite nicht.",

  "message.recorder.uploadError": "Fehler beim Hochladen.",

  "title.recorder.uploadFailure": "Hochladen fehlgeschlagen",

  "title.recorder.completed": "Abgeschlossen",

  "message.recorder.uploadComplete": "Upload abgeschlossen",

  "message.recorder.fileUploaded": "Datei erfolgreich hochgeladen",

  "message.recorder.uploadFailed": "Datei konnte nicht hochgeladen werden",

  "message.recorder.checkYourConnectionAndTryAgain":
    "Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut",

  "button.recorder.ok": "OK!",

  "title.recorder.shareMoments": "Senden Sie Ihre Nachricht",

  "subtitle.recorder.forThe1YearAnniversary": "Zum 1-jährigen Jubiläum",

  "subtitle.recorder.now": "Für Jetzt",

  "message.recorder.uploadMaxFilesLimit":
    "Laden Sie jeweils <code>1 Video</code> hoch.",

  "message.recorder.uploadLimit": "Maximale Grenze:",

  "message.recorder.videoSizeLimit": "<code>800MB</code> pro Video.",

  "button.recorder.send_video": "Video senden",

  "message.recorder.uploadTip":
    "Klicken Sie oben auf die Schaltfläche und wählen Sie das gerade aufgenommene Video aus!",

  "title.recorder.guide.instructionsToRecord": "Anleitung zur Aufnahme",

  "subtitle.recorder.guide.instructions":
    "<code>Öffnen Sie die Kamera</code> Ihres Geräts im Selfie-Modus und nehmen Sie Ihre Nachricht von bis zu <code>2 Minuten</code> auf!",

  "subtitle.recorder.guide.moreInstructions":
    "Kehren Sie anschließend hierher zurück, um Ihre Nachricht zu senden!",

  "message.recorder.instructions":
    "<code>Öffne die Kamera-App</code> deines Geräts im Selfie-Modus und nimm deine Nachricht mit einer Dauer von bis zu <code>2 Minuten</code> auf!",
  "button.recorder.sendVideo": "Video senden",
  "message.recorder.uploadTip.ios":
    "💡 Für bessere Qualität wähle ein Video aus deiner Mediathek",

  // uploader
  "button.uploader.send_photos": "Fotos senden",
  "button.uploader.send_video": "Video senden",
  "button.uploader.close": "Schließen",
  "button.uploader.share": "Teilen",
  "button.uploader.back": "Zurück",
  "button.uploader.send": "Senden",
  "button.uploader.continue": "Fortsetzen",
  "button.uploader.ok": "OK!",

  "title.uploader.success": "Erfolg!",
  "title.uploader.uploading": "Hochladen",
  "title.uploader.alert": "Warnung!",
  "title.uploader.saving": "Speichern",
  "title.uploader.waiting": "Warten",
  "title.uploader.share": "Teilen!",
  "title.uploader.error": "Fehler!",
  "title.uploader.upload": "Hochladen",
  "title.uploader.shareMoments": "Momente teilen",
  "title.uploader.uploadFailure": "Upload fehlgeschlagen",
  "title.uploader.completed": "Abgeschlossen",
  "title.uploader.terms": "Nutzungsbedingungen",

  "subtitle.uploader.filesWithError":
    "Dateien, die <code>nicht hochgeladen werden</code>:",
  "subtitle.uploader.uploadHistory": "Abgeschlossene Uploads",
  "subtitle.uploader.filesReadyToUpload": "Dateien bereit zum Hochladen:",

  "message.uploader.uploadMaxFilesLimit":
    "Laden Sie bis zu <code>50 Fotos oder 1 Video</code> gleichzeitig hoch.",
  "message.uploader.uploadLimit": "Maximale Grenze:",
  "message.uploader.photoSizeLimit": "<code>20MB</code> pro Foto",
  "message.uploader.videoSizeLimit": "<code>500MB</code> pro Video",
  "message.uploader.fileSizeError": "Datei überschreitet die zulässige Größe.",
  "message.uploader.uploading":
    "Bitte aktualisieren oder schließen Sie diese Seite nicht.",
  "message.uploader.uploadError": "Fehler beim Hochladen.",
  "message.uploader.maxFilesLimitError":
    "Wählen Sie maximal <code>50 Fotos</code> aus.",
  "message.uploader.notFoundFilesToUpload":
    "<code>Keine Dateien können hochgeladen werden</code>.",
  "message.uploader.checkFileSizeAndTryAgain":
    "Bitte überprüfen Sie die <code>Dateigröße</code> und versuchen Sie es erneut.",
  "message.uploader.uploadComplete": "Upload abgeschlossen",
  "message.uploader.allFilesUploaded": "Alle Dateien wurden hochgeladen",
  "message.uploader.nFilesUploaded": "{n} Dateien hochgeladen",
  "message.uploader.nFilesNotUploaded":
    "{n} Datei(en) wurden nicht hochgeladen",
  "message.uploader.noFilesUploaded": "Keine Dateien wurden hochgeladen",
  "message.uploader.checkYourConnectionAndTryAgain":
    "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
  "message.uploader.uploadVerySlow":
    "Wenn der Upload langsam ist, wählen Sie wenige Fotos gleichzeitig aus",
  "message.uploader.uploadTip":
    "Um die Qualität der Datei zu erhalten, laden Sie Dateien aus der Galerie Ihres Geräts hoch.",

  "title.guestForm": "Ihr Profil",
  "placeholder.guestForm.name": "Ihr Name oder Spitzname",
  "message.guestForm.nameRequired": "Name ist erforderlich",
  "message.guestForm.dataInfo":
    "Die angegebenen Daten sind nicht obligatorisch. Sie werden nur als Signatur auf den Fotos und Videos angezeigt, die Sie senden.",
  "button.guestForm.takePhoto": "Mach ein Selfie (optional)",
  "button.guestForm.submit": "Speichern",
  "button.guestForm.uploading": "Speichern...",
  "button.guestForm.skip": "Anonym fortfahren",
  "message.cameraNotAvailable":
    "Die Kamera konnte nicht zugegriffen werden. Bitte stellen Sie sicher, dass Sie die Berechtigungen für die Kamera erteilt haben.",
  "title.guestForm.cropPhoto": "Foto zuschneiden",
  "button.guestForm.selectPhoto": "Foto auswählen (optional)",

  "title.photoChallenge": "Foto-Herausforderung",
  "subtitle.photoChallenge.tasks": "Aufgaben",
  "subtitle.photoChallenge.done": "Erledigt",
  "message.photoChallenge.intro":
    "Das Ziel ist es, Fotos gemäß den angegebenen Zielen zu machen.",
  "message.photoChallenge.todo": "Machen Sie eine Herausforderung",
  "message.photoChallenge.done": "Herausforderungen abgeschlossen",
  "button.photoChallenge.start": "Starten",

  "title.quiz": "Quiz",
  "subtitle.quiz.intro": "Nehmen Sie die Herausforderung an?",
  "subtitle.quiz.result": "Ergebnis",
  "message.quiz.intro":
    "Beweisen Sie unter allen Gästen, dass Sie die Person sind, die das Paar am besten kennt!",
  "button.quiz.start": "Starten",
  "button.quiz.confirm": "Bestätigen",
  "message.quiz.result":
    "Sie haben {score} von {totalQuestions} Fragen in {time} Sekunden richtig beantwortet",
  "message.quiz.saving": "Speichern...",
  "button.quiz.share": "Ergebnis teilen",
  "message.quiz.congrats": "🎉 Herzlichen Glückwunsch! 🎉",

  "message.bingo.intro":
    "Können Sie das Bingo abschließen und dabei Spaß an jeder Herausforderung haben?",
  "button.bingo.start": "Starten",
  "label.bingo.fullCard": "Volle Karte",
  "label.bingo.line": "Linie",
  "label.bingo.firstColumn": "1. - Spalte",
  "label.bingo.firstRow": "1. - Reihe",
  "subtitle.bingo.results": "Ergebnisse",
  "message.bingo.selectChallenge":
    "Klicken Sie, um die Herausforderung zu sehen und abzuschließen",
  "button.bingo.removeChallenge": "Herausforderung entfernen",
  "button.bingo.continue": "Fortsetzen",
  "message.bingo.progress": "Setzen Sie die Bingo-Herausforderungen fort!",
  "button.bingo.share": "Teilen",

  "message.photoChallenge.intro.new":
    "Es ist einfach: Befolgen Sie die Anweisungen und haben Sie Spaß beim Fotografieren!",
  "message.photoChallenge.inProgress.new":
    "Wählen Sie unten eine Herausforderung aus und senden Sie Ihr Foto.",
  "button.photoChallenge.share": "Ergebnis teilen",
  "message.photoChallenge.completed":
    "Sie haben alle {total} Foto-Herausforderungen abgeschlossen!",
  "message.photoChallenge.congrats": "🎉 Herzlichen Glückwunsch! 🎉",

  "title.teamMatch": "Team-Match",
  "subtitle.teamMatch.intro": "Entdecken Sie Ihr Team",
  "subtitle.teamMatch.result": "Ergebnis",
  "message.teamMatch.intro":
    "Machen Sie den Test und finden Sie heraus, ob Sie zum Team {teamA} oder zum Team {teamB} gehören!",
  "button.teamMatch.start": "Starten",
  "button.teamMatch.next": "Weiter",
  "message.teamMatch.result": "Ihr Team ist <code>{team}</code>!",
  "message.teamMatch.saving": "Speichern...",
  "button.teamMatch.share": "Ergebnis teilen",

  "feed.loading": "Feed wird geladen...",
  "feed.empty": "Noch keine Elemente im Feed.",
  "feed.imageAlt": "Hochgeladenes Bild",
  "feed.anonymousGuest": "Anonymer Gast",
  "feed.imageUploader.title": "Hochgeladenes Foto",

  "feed.quiz.title": "Quiz",
  "feed.quiz.description":
    "{guestName} hat das Quiz abgeschlossen! Ergebnis: {score}/{total} in {time} Sekunden",
  "feed.photoChallenge.title": "Foto-Herausforderung",
  "feed.photoChallenge.description":
    "{guestName} hat die Herausforderung abgeschlossen: {challenge}",
  "feed.teamMatch.title": "Team-Match",
  "feed.teamMatch.description":
    "{guestName} hat am Team-Match teilgenommen. Ergebnis: {teamAName} {scoreA} x {scoreB} {teamBName}",
  "feed.newGuest.title": "Neuer Gast",
  "feed.newGuest.description": "{guestName} ist dem Event beigetreten",
  "feed.videoRecorder.title": "Neue Nachricht",
  "feed.videoRecorder.description":
    "{guestName} hat eine neue Nachricht gesendet",
  "feed.default.title": "Aktivität",
  "feed.default.description": "Eine neue Aktivität ist aufgetreten",

  "feed.ctaPost.ctaButton":
    "Gefällt dir die Veranstaltung? Poste auch ein Foto!",
  "feed.imageUploader.description":
    "{guestName} hat Dateien in die Party-Galerie hochgeladen",
  "feed.cdt-imageUploader.title": "Neue Nachricht",
  "feed.cdt-imageUploader.description":
    "{guestName} hat Dateien für den 1. Hochzeitstag hochgeladen!",
  "feed.quiz.ctaButton": "Teste dein Wissen",
  "feed.photoChallenge.ctaButton": "Mach auch bei einer Challenge mit",
  "feed.teamMatch.ctaButton": "Am Team Match teilnehmen",
  "feed.videoRecorder.ctaButton": "Nimm jetzt eine Nachricht auf",
  "feed.videoUploader.title": "Neue Nachricht",
  "feed.videoUploader.description":
    "{guestName} hat ein Video in die Party-Galerie hochgeladen",
  "feed.cdt-videoUploader.title": "Neue Nachricht",
  "feed.cdt-videoUploader.description":
    "{guestName} hat ein Video für den 1. Hochzeitstag hochgeladen!",
  "feed.newPost.title": "Neuer Beitrag",
  "feed.cdtVideoRecorder.description":
    "<code>{guestName}</code> hat bereits eine Nachricht für den <code>1. Hochzeitstag</code> hinterlassen!",
  "feed.cdtVideoRecorder.ctaButton": "Mach das Gleiche!",
  "feed.placeholder.newPost": "Beitrag erstellen...",
  "feed.placeholder.newPostMessage": "Schreibe deine Nachricht...",

  "feed.menu.title.interaction": "Dateien senden",
  "feed.menu.button.options.newPost": "Beitrag erstellen",
  "feed.menu.message.options.newPost": "Erstelle jetzt einen Beitrag!",
  "feed.menu.button.options.record": "Jetzt aufnehmen",
  "feed.menu.message.options.record":
    "Nimm jetzt deine besondere Nachricht auf!",
  "feed.menu.button.options.upload": "Dateien auswählen",
  "feed.menu.message.options.upload":
    "Teile die besten Fotos und Videos der Party!",
  "feed.menu.title.gallery": "Party-Galerie",
  "feed.menu.button.options.gallery": "Album ansehen",
  "feed.menu.message.options.gallery":
    "Sieh dir die Fotos der Veranstaltung an!",
  "feed.menu.title.games": "Spiele",
  "feed.menu.button.options.bingoGame": "Bingo",
  "feed.menu.message.options.bingoGame": "Spiele das Party-Bingo!",
  "feed.menu.button.options.photoChallengeGame": "Foto-Challenge",
  "feed.menu.message.options.photoChallengeGame":
    "Mach bei der Foto-Challenge mit!",
  "feed.menu.button.options.quizGame": "Quiz",
  "feed.menu.message.options.quizGame": "Teste dein Wissen!",
  "feed.menu.button.options.teamMatchGame": "Team Match",
  "feed.menu.message.options.teamMatchGame": "Zu welchem Team gehörst du?",
  "feed.menu.title.info": "Über die Veranstaltung",
  "feed.menu.button.options.foodMenu": "Menü",
  "feed.menu.message.options.foodMenu": "Sieh dir das Party-Menü an!",
  "feed.menu.button.options.schedule": "Programm",
  "feed.menu.message.options.schedule": "Sieh dir das Party-Programm an!",
  "feed.menu.title.guestInfo": "Deine Informationen",
  "feed.menu.options.anonymousGuest": "Anonymer Gast",
  "feed.menu.options.guestEditInfo":
    "Klicke, um deine Informationen zu bearbeiten!",
  "feed.menu.title.other": "Andere",
  "feed.menu.button.options.language": "Sprache",
  "feed.menu.message.options.languageInfo": "Klicke, um die Sprache zu ändern!",
  "feed.button.options.cancel": "Abbrechen",
  "feed.button.options.confirm": "Bestätigen",
  "feed.menu.button.options.share": "Teilen",
  "feed.menu.message.options.shareInfo": "Teile den Veranstaltungslink!",
  "feed.menu.button.options.about": "Über die Zeitkapsel",
  "feed.menu.message.options.about": "Erfahre mehr über die Zeitkapsel!",
  "feed.createPost.title": "Neuer Beitrag",
  "feed.button.creatingPost": "Wird veröffentlicht...",
  "feed.button.createPost": "Posten",
  "feed.editImage.title": "Bild bearbeiten",
  "feed.newPost.selectImage": "Bild auswählen",
  "feed.createPost.info.sendingPostImage": "Bild wird gesendet...",
  "feed.createPost.info.creatingPost": "Beitrag wird erstellt...",
  "feed.createPost.info.finalizingPost": "Wird abgeschlossen...",
  "feed.menu.button.options.games": "Spiele",
  "feed.modalGames.title": "Party-Spiele",
  "feed.bingo.result.line": "Reihe",
  "feed.bingo.result.column": "Spalte",
  "feed.bingo.result.fullCard": "Volle Karte",
  "feed.bingo.title": "Bingo",
  "feed.bingo.description":
    "{guestName} hat eine {challenge} im Bingo abgeschlossen",
  "feed.bingo.ctaButton": "Spiel auch Bingo",
  "feed.deletePost.title": "Beitrag löschen",
  "feed.deletePost.message":
    "Bist du sicher, dass du diesen Beitrag löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",

  "title.uploader.modalMixedEventTitle":
    "WANN sollen die Brautleute dein Foto oder Video erhalten?",
  "button.options.sendNow": "Jetzt senden",
  "message.options.sendNow": "Die Brautleute erhalten die Dateien sofort!",
  "button.options.sendLater": "Zum 1. Hochzeitstag",
  "message.options.sendLater": "Für die Zeitkapsel des Events speichern!",

  "button.cancel": "Abbrechen",
  "button.delete": "Löschen",
  "button.quiz.continue": "Fortsetzen",
  "button.recorder.recorder.back": "Zurück",
  "button.teamMatch.continue": "Fortsetzen",
  "cropper.remove.frame": "Rahmen entfernen",
  "cropper.use.frame": "Rahmen verwenden",
  "error.guestForm.fileTooLarge": "Die Datei darf maximal 10 MB groß sein",
  "error.guestForm.invalidFileType":
    "Bitte wählen Sie eine gültige Bilddatei aus",
  "error.guestForm.removePhotoFailed":
    "Foto konnte nicht entfernt werden. Bitte versuchen Sie es erneut.",
  "error.guestForm.saveFailed":
    "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "error.guestForm.updateFailed":
    "Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "error.guestForm.uploadFailed":
    "Foto-Upload fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "title.guestForm.unsavedChanges": "Nicht gespeicherte Änderungen",
  "message.guestForm.unsavedChanges":
    "Sie haben nicht gespeicherte Änderungen. Möchten Sie ohne Speichern verlassen?",
  "button.guestForm.cancel": "Abbrechen",
  "button.guestForm.exitWithoutSaving": "Ohne Speichern verlassen",
  "message.bingo.remove.warning":
    "Durch das Löschen dieser Herausforderung werden Ihre Ergebnisse neu berechnet.",
  "message.bingo.remove.warning.detail1":
    "Von der Löschung betroffene Zeilen und Spalten werden überprüft.",
  "message.bingo.remove.warning.detail2":
    "Wenn es andere abgeschlossene Erfolge gibt, wird die Zeit auf den aktuellen Zeitpunkt aktualisiert.",
  "message.guest.nameRequired": "Name ist erforderlich",
  "message.quiz.progress":
    "Das Quiz läuft noch! Mach weiter und zeig, was in dir steckt!",
  "message.teamMatch.progress":
    "Das Spiel läuft noch! Mach weiter und entdecke dein Team!",
  "title.feed": "Feed der Party",
};

export default message;
